import { Component } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  min-height: 60vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px 20px;
  text-align: center;
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.h2};
`;

const Retry = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: ${({ theme }) => theme.radii.md};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.onPrimary};
  font-weight: 600;
  cursor: pointer;
`;

/**
 * Ошибка рендера в одном компоненте больше не роняет весь сайт в белый экран.
 */
export class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Здесь можно подключить Sentry и т.п.
    console.error("Unhandled UI error:", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Wrapper role="alert">
        <Title>Что-то пошло не так</Title>
        <p>Попробуйте обновить страницу.</p>
        <Retry type="button" onClick={() => window.location.reload()}>
          Обновить
        </Retry>
      </Wrapper>
    );
  }
}

export default ErrorBoundary;
